module.exports = __webpack_public_path__ + "static/media/eps-file-format.20489cf3.png";